import axios from 'axios';

export const httpApi = axios.create({
    baseURL: process.env.REACT_APP_SIGNUP_API_URL,
});

httpApi.interceptors.request.use((config) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    config.headers = { ...config.headers, Authorization: process.env.REACT_APP_SIGNUP_API_TOKEN };

    return config;
});

export interface ApiErrorData {
    message: string;
}
